import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/Logo.png";

const pageStyle = {
  backgroundColor: "#f3f6fa",
  minHeight: "100vh",
  padding: "24px",
};

const containerStyle = {
  maxWidth: "900px",
  margin: "0 auto",
};

const sectionStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #d7dfea",
  borderRadius: "10px",
  padding: "16px",
  marginTop: "12px",
};

const headingStyle = {
  margin: "0 0 8px 0",
  color: "#1c2a40",
  fontSize: "18px",
};

const textStyle = {
  margin: 0,
  color: "#1c2a40",
  lineHeight: "1.6",
  fontSize: "14px",
};

export default function Support() {
  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <img
          src={Logo}
          alt="managd logo"
          style={{ width: "220px", maxWidth: "100%", height: "auto", display: "block", marginBottom: "12px" }}
        />
        <h1 style={{ margin: 0, color: "#1c2a40" }}>managd Support</h1>
        <p style={{ ...textStyle, marginTop: "8px" }}>
          Support information for the managd mobile app and web portal.
        </p>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>Contact Support</h2>
          <p style={textStyle}>
            Email: <strong>admin@managd.services</strong>
          </p>
          <p style={{ ...textStyle, marginTop: "8px" }}>
            For organisation-specific issues such as allocations, rates, approvals, or access,
            contact your organisation administrator first.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>Account Deletion</h2>
          <p style={textStyle}>
            Workers who signed up in the mobile app can delete their account from inside the app:
            open <strong>Profile</strong>, then select <strong>Delete Account</strong>.
          </p>
          <p style={{ ...textStyle, marginTop: "8px" }}>
            Deleting an account permanently removes the app sign-in and worker profile. Some
            historical business records such as timesheets or invoices may still be retained
            where required for legal or recordkeeping purposes.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>Privacy</h2>
          <p style={textStyle}>
            Review the <Link to="/privacy-policy">Privacy Policy</Link> for details about data
            collection, storage, and usage.
          </p>
        </section>
      </div>
    </div>
  );
}
